import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MenuSistema } from '../../../../models/menuItens.model';
import { MenuService } from '../../../../services/menu.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  menus: MenuSistema[] = [];
  filteredMenus: MenuSistema[] = [];
  paginatedMenus: MenuSistema[] = [];

  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private menuService: MenuService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadMenus();
  }

  loadMenus(): void {
    this.menuService.getMenus().subscribe({
      next: (data) => {
        this.menus = data;
        this.filteredMenus = data;
        this.totalPages = Math.max(1, Math.ceil(this.filteredMenus.length / this.itemsPerPage));
        this.setPage(1);
        this.cdr.detectChanges();
      },
      error: (error) => {
        const mensagem = error?.error?.message ?? 'Erro ao carregar menus.';
        this.toastr.error(mensagem);
      }
    });
  }

  search(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredMenus = this.menus.filter(menu =>
      menu.title.toLowerCase().includes(term)
    );

    this.totalPages = Math.max(1, Math.ceil(this.filteredMenus.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredMenus.length);
    this.paginatedMenus = this.filteredMenus.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from(
      { length: (this.endPage - this.startPage) + 1 },
      (_, i) => this.startPage + i
    );
  }

  novoMenu(): void {
    this.router.navigate(['/home', 'sistema-menu-manutencao']);
  }

  editarMenu(id: number): void {
    this.router.navigate(['/home', 'sistema-menu-manutencao', id]);
  }

  deleteMenu(id: number): void {
    this.menuService.deleteMenu(id).subscribe({
      next: () => {
        this.loadMenus();
        this.toastr.success('Menu excluido com sucesso!');
      },
      error: (error) => {
        const mensagem = error?.error?.message ?? 'Erro ao excluir menu.';
        this.toastr.error(mensagem);
      }
    });
  }

}
